module.exports = __webpack_public_path__ + "static/interest2-284275d5317b15fb789f941ce72f2721.jpg";